var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { staticClass: "mt" },
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [_c("app-account-settings", { staticClass: "grow" })],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [_c("app-change-password", { staticClass: "grow" })],
        1
      ),
      _vm.isOwner
        ? _c(
            "w-col",
            { attrs: { xs: "12" } },
            [_c("app-billing-address", { staticClass: "grow" })],
            1
          )
        : _vm._e(),
      _vm.isLockScreenNfcEnabled
        ? _c(
            "w-col",
            { attrs: { xs: "12", lg: "6" } },
            [_c("app-lock-screen-nfc-badges", { staticClass: "grow" })],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { xs: "12", lg: "6" } },
        [_c("app-qr-login", { staticClass: "grow" })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }